import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { WaitlistProvider } from "@/context/WaitlistContext";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Products from "@/pages/Products";
import ProductDetail from "@/pages/ProductDetail";
import Vision from "@/pages/Vision";
import About from "@/pages/About";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import Contact from "@/pages/Contact";
import Careers from "@/pages/Careers";
import Technology from "@/pages/Technology";
import AIPlatform from "@/pages/AIPlatform";
import Legal from "@/pages/Legal";
import "@/App.css";

// Scroll back to the top whenever the route changes, so each page opens at the top.
function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

// Production origin used for canonical/OG URLs (always the live domain, never localhost).
const SITE_URL = "https://naarisutra.in";

// Keep <link rel="canonical"> and og:url pointing at the CURRENT route, not the
// homepage. Without this, the static canonical in index.html makes Google treat
// every page as an "Alternate page with proper canonical tag" and skip indexing it.
function CanonicalUrl() {
  const { pathname } = useLocation();
  useEffect(() => {
    let path = pathname;
    if (path.length > 1 && path.endsWith("/")) path = path.slice(0, -1); // drop trailing slash (except root)
    const url = SITE_URL + (path === "/" ? "/" : path);

    let link = document.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", url);

    const og = document.querySelector('meta[property="og:url"]');
    if (og) og.setAttribute("content", url);
  }, [pathname]);
  return null;
}

export default function App() {
  return (
    <WaitlistProvider>
      <BrowserRouter>
        <ScrollToTop />
        <CanonicalUrl />
        <div className="App">
          <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/products" element={<Products />} />
            <Route path="/products/:slug" element={<ProductDetail />} />
            <Route path="/vision" element={<Vision />} />
            <Route path="/about" element={<About />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/careers" element={<Careers />} />
            <Route path="/technology" element={<Technology />} />
            {/* Orphaned in the source (nothing links to it); routed here so it stays reachable. */}
            <Route path="/ai-platform" element={<AIPlatform />} />
            <Route path="/privacy" element={<Legal />} />
            <Route path="/terms" element={<Legal />} />
            {/* Unknown paths fall back to the home page. */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Footer />
          <Toaster />
        </div>
      </BrowserRouter>
    </WaitlistProvider>
  );
}
